import ClassicExtension from "./ClassicExtension";

export default class OffcanvasAutoShowExtension extends ClassicExtension {

    private closeEventInitialized = false;

    protected init($root: JQuery): void {
        this.initCloseEvent();

        $root.find('.offcanvas[data-auto-show="1"]').each((i, el) => {
            $(el).offcanvas('show');

            const url = $(el).data('share-url');
            if (url && window.history.pushState) {
                window.history.pushState(null, '', url);
            }

            $('tr.active').removeClass('active');
            const detailId = $(el).data('detail-id');
            if (detailId) {
                $('tr[data-id="' + detailId + '"]').addClass('active');
            }
        });
    }

    private initCloseEvent(): void {
        if (this.closeEventInitialized) {
            return;
        }

        this.closeEventInitialized = true;
        document.addEventListener('hidden.bs.offcanvas', event => {
            const offcanvas = event.target;
            if (!(offcanvas instanceof HTMLElement)
                || !offcanvas.classList.contains('offcanvas')
                || !offcanvas.hasAttribute('data-detail-id')) {
                return;
            }

            $('tr.active').removeClass('active');
        });
    }
}
